// AUTO-GENERATED by scripts/gen_rule_catalog.py.
// Source: skillspector.nodes.analyzers.pattern_defaults.
// Re-run after upgrading SkillSpector.

export interface SkillSpectorRule {
  id: string;
  category: string;
  description: string;
}

export const SKILLSPECTOR_RULES: Record<string, SkillSpectorRule> = {
  "AST1": {
    "id": "AST1",
    "category": "Tool Misuse",
    "description": "Direct exec() call allows arbitrary code execution. An attacker can inject code that runs with the full privileges of the process."
  },
  "AST2": {
    "id": "AST2",
    "category": "Tool Misuse",
    "description": "Direct eval() call evaluates arbitrary expressions. This can be exploited to execute malicious code or exfiltrate data."
  },
  "AST3": {
    "id": "AST3",
    "category": "Tool Misuse",
    "description": "Dynamic __import__() can load arbitrary modules at runtime, bypassing static analysis and potentially importing malicious code."
  },
  "AST4": {
    "id": "AST4",
    "category": "Tool Misuse",
    "description": "subprocess module calls execute external commands. Without careful input validation, this enables command injection."
  },
  "AST5": {
    "id": "AST5",
    "category": "Tool Misuse",
    "description": "os.system() and os exec-family calls run shell commands with the process's full privileges, enabling arbitrary command execution."
  },
  "AST6": {
    "id": "AST6",
    "category": "Tool Misuse",
    "description": "compile() creates code objects from strings. When combined with exec()/eval(), it enables obfuscated code execution."
  },
  "AST7": {
    "id": "AST7",
    "category": "Tool Misuse",
    "description": "Dynamic getattr() with a non-literal attribute name can access arbitrary object attributes, potentially bypassing access controls."
  },
  "AST8": {
    "id": "AST8",
    "category": "Tool Misuse",
    "description": "A dangerous execution chain combines code execution (exec/eval) with a dynamic source (network, encoded data, dynamic import), creating a high-confidence attack vector."
  },
  "E1": {
    "id": "E1",
    "category": "Data Exfiltration",
    "description": "Data is being sent to an external URL. This could be legitimate telemetry or data exfiltration. Manual review is recommended."
  },
  "E2": {
    "id": "E2",
    "category": "Data Exfiltration",
    "description": "Code accesses environment variables that may contain secrets (API keys, tokens). This is a common pattern for credential theft."
  },
  "E3": {
    "id": "E3",
    "category": "Data Exfiltration",
    "description": "Code scans file system directories looking for sensitive files. This could be reconnaissance for credential theft."
  },
  "E4": {
    "id": "E4",
    "category": "Data Exfiltration",
    "description": "Code or instructions that leak agent conversation context to external services, potentially exposing sensitive user interactions."
  },
  "EA1": {
    "id": "EA1",
    "category": "Excessive Agency",
    "description": "Skill grants unrestricted tool access without appropriate constraints. An agent with unfettered tool access can perform arbitrary actions including file modification, network requests, and code execution."
  },
  "EA2": {
    "id": "EA2",
    "category": "Excessive Agency",
    "description": "Skill enables autonomous high-impact decisions without human-in-the-loop verification. Critical operations (destructive commands, financial transactions, data deletion) should require explicit user confirmation."
  },
  "EA3": {
    "id": "EA3",
    "category": "Excessive Agency",
    "description": "Skill's behavior or capabilities extend beyond its stated purpose. Scope creep allows an agent to perform actions unrelated to its documented functionality, increasing the attack surface."
  },
  "EA4": {
    "id": "EA4",
    "category": "Excessive Agency",
    "description": "Skill allows unbounded resource consumption (API calls, storage, compute). Without rate limits or quotas, a compromised or misbehaving agent can cause denial-of-service or cost overruns."
  },
  "LP1": {
    "id": "LP1",
    "category": "MCP Least Privilege",
    "description": "Code uses capabilities (network, shell, file write, etc.) not covered by declared permissions. The skill does more than it claims, which may indicate deceptive intent."
  },
  "LP2": {
    "id": "LP2",
    "category": "MCP Least Privilege",
    "description": "Permission list contains a wildcard ('*' or 'all'), granting blanket access with no least-privilege boundary. This disables permission-based security controls entirely."
  },
  "LP3": {
    "id": "LP3",
    "category": "MCP Least Privilege",
    "description": "Skill has no permissions field in its manifest but code uses detectable capabilities. Without declared permissions, the skill's intent is opaque and cannot be validated."
  },
  "LP4": {
    "id": "LP4",
    "category": "MCP Least Privilege",
    "description": "Permission is declared but no corresponding code capability was detected. This may indicate removed functionality or pre-staging for future abuse."
  },
  "MP1": {
    "id": "MP1",
    "category": "Memory Poisoning",
    "description": "Skill injects content designed to persist in agent memory or context across interactions. Persistent injection can alter agent behavior long after the initial interaction."
  },
  "MP2": {
    "id": "MP2",
    "category": "Memory Poisoning",
    "description": "Skill attempts to fill the context window with filler content, displacing legitimate instructions and safety constraints. This can degrade agent performance or bypass safety boundaries."
  },
  "MP3": {
    "id": "MP3",
    "category": "Memory Poisoning",
    "description": "Skill manipulates agent memory, state, or stored context. Memory corruption can alter personality, override safety rules, or cause unpredictable behavior."
  },
  "OH1": {
    "id": "OH1",
    "category": "Output Handling",
    "description": "Model output is used without validation or sanitization. Unvalidated output injected into downstream contexts (SQL, shell, HTML) enables injection attacks and arbitrary code execution."
  },
  "OH2": {
    "id": "OH2",
    "category": "Output Handling",
    "description": "Output from one security context is used in another without boundary enforcement. Cross-context output flow can leak sensitive information or escalate privileges across trust boundaries."
  },
  "OH3": {
    "id": "OH3",
    "category": "Output Handling",
    "description": "Output size or generation rate is not bounded. Unbounded output enables denial-of-service through resource exhaustion, log flooding, or context-window stuffing."
  },
  "P1": {
    "id": "P1",
    "category": "Prompt Injection",
    "description": "This pattern attempts to override system instructions or ignore safety constraints. Without LLM analysis, manual review is recommended."
  },
  "P2": {
    "id": "P2",
    "category": "Prompt Injection",
    "description": "Hidden instructions were detected in comments or invisible text. These could contain malicious directives. Manual review is recommended."
  },
  "P3": {
    "id": "P3",
    "category": "Data Exfiltration",
    "description": "Instructions found that direct the agent to transmit conversation context or user data to external services."
  },
  "P4": {
    "id": "P4",
    "category": "Prompt Injection",
    "description": "Subtle instructions detected that may alter agent decision-making or introduce hidden biases."
  },
  "P5": {
    "id": "P5",
    "category": "Prompt Injection",
    "description": "This content may contain harmful instructions that could cause physical harm if followed. CRITICAL: Review carefully before use."
  },
  "P6": {
    "id": "P6",
    "category": "System Prompt Leakage",
    "description": "Skill contains instructions that could directly expose system prompts, internal rules, or hidden instructions to users or external parties."
  },
  "P7": {
    "id": "P7",
    "category": "System Prompt Leakage",
    "description": "Skill contains patterns that could indirectly extract system prompts through rephrasing, translation, summarization, or side-channel techniques."
  },
  "P8": {
    "id": "P8",
    "category": "System Prompt Leakage",
    "description": "Skill contains patterns that exfiltrate system prompts or internal instructions via tool calls (file writes, network requests, logging)."
  },
  "PE1": {
    "id": "PE1",
    "category": "Privilege Escalation",
    "description": "Skill requests more permissions than appear necessary for its stated functionality. Review if elevated access is justified."
  },
  "PE2": {
    "id": "PE2",
    "category": "Privilege Escalation",
    "description": "Commands invoke sudo or root privileges. Verify this elevated access is necessary and justified."
  },
  "PE3": {
    "id": "PE3",
    "category": "Privilege Escalation",
    "description": "Code accesses credential files (SSH keys, AWS credentials, etc.). This could indicate credential theft attempts."
  },
  "RA1": {
    "id": "RA1",
    "category": "Rogue Agent",
    "description": "Skill modifies its own code, configuration, or behavior at runtime. Self-modification enables an agent to escalate privileges, disable safety constraints, or install persistent backdoors."
  },
  "RA2": {
    "id": "RA2",
    "category": "Rogue Agent",
    "description": "Skill establishes unauthorized persistence across sessions via cron jobs, startup scripts, or state files. Session persistence allows an attacker to maintain access beyond the current interaction."
  },
  "SC1": {
    "id": "SC1",
    "category": "Supply Chain",
    "description": "Dependencies lack version pinning, allowing potential malicious package updates. Consider pinning versions."
  },
  "SC2": {
    "id": "SC2",
    "category": "Supply Chain",
    "description": "Remote code is downloaded and executed. This bypasses code review and could introduce malicious code."
  },
  "SC3": {
    "id": "SC3",
    "category": "Supply Chain",
    "description": "Code contains obfuscation (base64, hex encoding with execution). This is often used to hide malicious functionality."
  },
  "SC4": {
    "id": "SC4",
    "category": "Supply Chain",
    "description": "Dependency has known vulnerabilities (CVEs). Using packages with unpatched security flaws exposes the environment to known exploits."
  },
  "SC5": {
    "id": "SC5",
    "category": "Supply Chain",
    "description": "Dependency appears abandoned or unmaintained. Abandoned packages no longer receive security patches, leaving known and future vulnerabilities unaddressed."
  },
  "SC6": {
    "id": "SC6",
    "category": "Supply Chain",
    "description": "Package name closely resembles a popular package, suggesting possible typosquatting. Attackers publish malicious packages with similar names to trick developers into installing them."
  },
  "TM1": {
    "id": "TM1",
    "category": "Tool Misuse",
    "description": "Tool parameters are crafted to achieve unintended or unsafe behavior. Parameter abuse can bypass intended safety checks (e.g. shell=True, --force, dangerous glob patterns)."
  },
  "TM2": {
    "id": "TM2",
    "category": "Tool Misuse",
    "description": "Tool calls are chained to bypass individual safety checks or escalate capabilities beyond what any single tool call would allow."
  },
  "TM3": {
    "id": "TM3",
    "category": "Tool Misuse",
    "description": "Tool defaults are unsafe or overly permissive (e.g. disabled TLS verification, no authentication, world-writable permissions). Unsafe defaults widen the attack surface."
  },
  "TP1": {
    "id": "TP1",
    "category": "MCP Tool Poisoning",
    "description": "Hidden instructions detected in skill metadata (description, triggers, or parameters). These concealed directives can steer LLM behavior without the user's knowledge."
  },
  "TP2": {
    "id": "TP2",
    "category": "MCP Tool Poisoning",
    "description": "Unicode deception detected in skill identifiers or descriptions. Homoglyphs, RTL overrides, or invisible characters can make malicious content appear benign."
  },
  "TP3": {
    "id": "TP3",
    "category": "MCP Tool Poisoning",
    "description": "Instruction injection patterns found in parameter descriptions or default values. Parameter metadata is read by LLMs and can override intended behavior."
  },
  "TP4": {
    "id": "TP4",
    "category": "MCP Tool Poisoning",
    "description": "Skill description does not match actual code behavior. The declared purpose diverges from what the code actually does, indicating possible deception."
  },
  "TR1": {
    "id": "TR1",
    "category": "Trigger Abuse",
    "description": "Skill uses overly broad trigger patterns that match common words or phrases, causing it to activate in unintended contexts and potentially shadow other skills."
  },
  "TR2": {
    "id": "TR2",
    "category": "Trigger Abuse",
    "description": "Skill trigger shadows a common built-in command or another skill's trigger, potentially intercepting requests meant for trusted functionality."
  },
  "TR3": {
    "id": "TR3",
    "category": "Trigger Abuse",
    "description": "Skill trigger uses vague or generic keywords designed to maximize activation frequency rather than target specific use cases."
  },
  "TT1": {
    "id": "TT1",
    "category": "Data Exfiltration",
    "description": "Data flows directly from a source (env vars, files, network) to a sink (network output, exec, file write) without intermediate validation."
  },
  "TT2": {
    "id": "TT2",
    "category": "Data Exfiltration",
    "description": "Data from a source is assigned to a variable that is later passed to a sink, creating a variable-mediated taint flow."
  },
  "TT3": {
    "id": "TT3",
    "category": "Data Exfiltration",
    "description": "Credentials or environment variables flow to a network sink. This is a high-confidence indicator of credential exfiltration."
  },
  "TT4": {
    "id": "TT4",
    "category": "Data Exfiltration",
    "description": "File contents flow to a network sink. This may indicate data exfiltration of sensitive files."
  },
  "TT5": {
    "id": "TT5",
    "category": "Prompt Injection",
    "description": "External input (network, user) flows to a code execution sink. This enables remote code execution or command injection."
  },
  "YR1": {
    "id": "YR1",
    "category": "YARA Match",
    "description": "YARA rule matched a known malware signature (reverse shell, backdoor, ransomware, C2 framework, or info stealer)."
  },
  "YR2": {
    "id": "YR2",
    "category": "YARA Match",
    "description": "YARA rule matched a known webshell pattern (PHP, Python, JSP, or ASPX webshell)."
  },
  "YR3": {
    "id": "YR3",
    "category": "YARA Match",
    "description": "YARA rule matched cryptocurrency mining indicators (stratum protocol, mining pools, miner binaries, or cryptojacking scripts)."
  },
  "YR4": {
    "id": "YR4",
    "category": "YARA Match",
    "description": "YARA rule matched a hack tool or exploit indicator (offensive tools, reconnaissance, privilege escalation, or exploit frameworks)."
  }
};
